import { authGet, authJsonGet, getSavedUser } from "functions/BaseAxios";
import { bookingJQL } from "functions/JQL/BookingJQL";

export const MY_TRIP = 'MY_TRIP';
export const BOOKING_DETAIL = 'BOOKING_DETAIL';
export function getMyTrips(page?: any,params?: any) {
    return async (dispatch: DispatchGeneral) => {
        let data;
        try {
            data = await authGet("auth/my-trips/"+page);
        } catch (e) {
            data = { code: 201 };
        }
        let trips;
        if (params) {
            trips = params;
            if (data.code == 200) {
                data.payload.data.map((item:any, index:any) => {
                    trips.push(item)
                })
            }
        }
        
        dispatch({
            type: MY_TRIP,
            payload: data.code == 200 ? params ? trips : data.payload.data : [],
        });
    };
}

export function getBookingDetail(id?: any) {
    return async (dispatch: DispatchGeneral) => {
        let data;
        try {
            data = await authGet(`auth/booking/${id}`);
        } catch (e) {
            data = { code: 201 };
        }
        dispatch({
            type: BOOKING_DETAIL,
            payload: data.code == 200 ? data.payload.data : [],
        });
    };
}